import { Components } from '@mui/material/styles';

export const MuiChip: Components['MuiChip'] = {
  styleOverrides: {
    root: {
      borderRadius: '6px',
      fontWeight: 500,
      '&.MuiChip-sizeSmall': {
        height: '24px',
        fontSize: '0.75rem',
      },
      '&.MuiChip-sizeMedium': {
        height: '32px',
        fontSize: '0.875rem',
      },
      '&.MuiChip-sizeLarge': {
        height: '40px',
        fontSize: '1rem',
      },
    },
    label: {
      padding: '0 12px',
    },
    icon: {
      fontSize: '1rem',
      marginLeft: '8px',
    },
    deleteIcon: {
      fontSize: '1rem',
      marginRight: '8px',
    },
  },
};
